import * as React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Button, Grid, Input, Text } from '@siteground/styleguide';

import { sendTranscript } from '../../app-communication/actions/from-client-frontend';

export const ThankYouFooter = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [email, setEmail] = React.useState();
  const [isTranscriptSent, setIsTranscriptSent] = React.useState(false);
  const [error, setError] = React.useState(null);
  if (isTranscriptSent) {
    return (
      <Grid align="center" style={{ width: '100%' }}>
        <Text>{intl.formatMessage({ id: 'translate.thank.you.chat.transcript.sent.notice' })}</Text>
      </Grid>
    );
  }
  return (
    <Grid gap="x-small" style={{ width: '100%' }}>
      <Text>{intl.formatMessage({ id: 'translate.thank.you.chat.transcript.notice' })}</Text>

      <Grid align="flex-end" autoflow="column" gap="x-small">
        <Input
          label={intl.formatMessage({ id: 'translate.login.label.email' })}
          value={email}
          state={error ? 'error' : undefined}
          validationMessage={error ? intl.formatMessage({ id: error }) : undefined}
          onChange={(event) => setEmail(event.target.value)}
        />

        <Button
          color="primary"
          type="ghost"
          size="small"
          onClick={() =>
            dispatch(
              sendTranscript({
                email,
                onComplete: () => setIsTranscriptSent(true),
                onFailure: (error) => setError(error.message)
              })
            )
          }
        >
          {intl.formatMessage({ id: 'translate.generic.send' })}
        </Button>
      </Grid>
    </Grid>
  );
};
